import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SearchService } from 'app/components/search/search.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { Subject, takeUntil } from 'rxjs';
import { SharedService } from '../../services/shared.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { FiltersService } from 'app/components/filters/filters.service';

@Component({
  selector: 'app-filter-items',
  templateUrl: './filter-items.component.html',
  styleUrls: ['./filter-items.component.css']
})
export class FilterItemsComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  @Input() items: Array<any> = [];
  @Input() type: string = '';
  @Input() isFather: boolean = false;
  @Input()index: number = 0;
  isArray: boolean = true;
  childsPropertyName: string = '';
  searchText: string = '';

  currentUrl: string;
  
  private readonly destroy$ = new Subject();

  selectedView: string;

  constructor(public translateService: TranslateService, public searchService: SearchService, public utilsService: UtilsService,
    private sharedService:SharedService, private analyticsService: AnalyticsService, public filtersService: FiltersService
  ) { }

  toggleItem(item, isFather) {

    if (isFather) {
      item.opened = !item.opened;
    } else {
      item['checked'] = !item['checked'];
      this.updateFilter(item, this.type === 'multiEvents' ? 'sapCode' : 'id');
    }

  }

  updateFilter(item, valueKey) {

    this.type = this.type || 'Hierarchical';
    let propertyName = this.utilsService.setPropertyName(this.type);
    let active = item['checked'];

    //this.sharedService.updateParam(this.currentUrl);

    if (active) {
      this.searchService.addItemToProperty(propertyName, item[valueKey], item);
      this.analyticsService.sendFilters('add', propertyName, propertyName == 'selectedMultiEvents' ? item.label : item.translations, item[valueKey]);
    } else {
      this.searchService.removeItemFromProperty(propertyName, item[valueKey], item);
      this.analyticsService.sendFilters('remove', propertyName, propertyName == 'selectedMultiEvents' ? item.label : item.translations, item[valueKey]);
    }
    
    this.sharedService.updateUrl();

    let unifiedSearchIn = this.searchService.getSearchConfig();

    this.unifiedSearch(unifiedSearchIn);

  }


  unifiedSearch(unifiedSearchIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.unifiedSearch(unifiedSearchIn)
    .pipe(takeUntil(this.destroy$))
      .subscribe((data: object) => {
        this.unifiedSearchOk(data);
      },
        error => {
          this.unifiedSearchError(error);
        });

  }

  unifiedSearchOk(data) {
    this.loader.count--;
    this.searchService.setResetList(true);
    this.searchService.setItemsObs(data.list);
    this.searchService.setNumItemsObs(data.numElements);
    this.analyticsService.sendViewItemList(data.list, this.searchService.getSearchConfig()['filter'] === 'ONLY_EXHIBITORS' ? 'exhibitor' : 'product', this.selectedView);
  }

  unifiedSearchError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }



  ngOnInit() {

    this.isArray = Array.isArray(this.items);

    if (this.type === 'hierarchicalProperties') {
      this.childsPropertyName = 'childHierarchicalProperties';
    } else {
      this.childsPropertyName = 'properties';
    }

    this.items[this.childsPropertyName] = this.items[this.childsPropertyName] || [];

    if (this.items[this.childsPropertyName].length > 0) {
      this.isFather = true;
    } else if (this.type !== 'Ods') {
      this.isFather = false;
    }

    if (this.isFather) {
      this.items['opened'] = false;
    } else {
      this.items['checked'] = this.items['checked'] || false;
    }

    this.filtersService.getSelectedView().subscribe(data => {
      this.selectedView = data;
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
